import { loadAuthFromStorage } from "../auth/authStorage";
import { loadUnits } from "../units/unitsStorage";
import type { Lang } from "./i18n";
import { pickLang,translateKey } from "./i18n";

export function getCurrentLangFromStorage(): Lang {
  try {
    const stored = loadAuthFromStorage();
    const units = loadUnits(stored.info?.accountId);
    return pickLang({
      unitsLocale: units.locale,
      userLanguage: stored.info?.language || null,
      browserLanguage: typeof navigator !== "undefined" ? navigator.language : ""
    });
  } catch {
    return "de";
  }
}

export function trStatic(key: string): string {
  const lang = getCurrentLangFromStorage();
  return translateKey(lang, key);
}


















